import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import H from "./H.js";
export var H1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(H, _extends({
    ref: ref,
    level: 1
  }, props));
});
export var H2 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(H, _extends({
    ref: ref,
    level: 2
  }, props));
});
export var H3 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(H, _extends({
    ref: ref,
    level: 3
  }, props));
});
export var H4 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(H, _extends({
    ref: ref,
    level: 4
  }, props));
});